import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "Redux/Actions/actionTypes";
import EnableOnlineBanking from "Communication/ApiClasses/EnableOnlineBankingRequest";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import STRINGS from "Constants/Strings";

// worker
function* handleEnableOnlineBanking(action) {
  // Logging for debugging the messages
  console.log(
    "Loading Start Message:",
    STRINGS.ONLINE_BANKING.ONLINE_BANKING_SPINNER_MSG_BEGIN
  );
  console.log(
    "Loading End Message:",
    STRINGS.ONLINE_BANKING.ONLINE_BANKING_SPINNER_MSG_END
  );

  // Dispatching loading start with the begin message
  yield put(
    doLoadingStart(
      STRINGS.ONLINE_BANKING.API_KEYS.ENABLE_ONLINE_BANKING,
      STRINGS.ONLINE_BANKING.ONLINE_BANKING_SPINNER_MSG_BEGIN
    )
  );

  // Preparing the request data
  const enableOnlineBanking = new EnableOnlineBanking(
    action.data.applicantId,
    action.data.applicationId,
    action.data.debitCardProductId,
    action.data.password
  );

  try {
    const result = yield call(enableOnlineBanking.getData);
    yield put({
      type: actionTypes.ENABLE_ONLINE_BANKING_SUCCESS,
      response: result,
    });
    yield call(action.callback, result);
  } catch (e) {
    yield put({
      type: actionTypes.ENABLE_ONLINE_BANKING_ERROR,
      error: e.message,
    });
  } finally {
    yield put(
      doLoadingFinish(STRINGS.ONLINE_BANKING.API_KEYS.ENABLE_ONLINE_BANKING)
    );
  }
}

// watcher
function* enableOnlineBankingSaga() {
  yield takeLatest(
    actionTypes.ENABLE_ONLINE_BANKING,
    handleEnableOnlineBanking
  );
}

export default enableOnlineBankingSaga;
